
export enum SurveyTypeEnum {
    'ProjectsByPercentageActivitiesBySelection' = 1,
    'ProjectsByPercentageNoActivity' = 2,
    'ProjectsBySelectionActivitiesByPercentage' = 3,
    'ProjectsBySelectionActivitiesBySelection' = 4,
    'ProjectsBySelectionNoActivity' = 5,
    'NoProjectActivitiesByPercentage' = 6,
    'NoProjectActivitiesBySelection' = 7,
    'NoProjectNoActivity' = 8,
    'DualAllocationSimple' = 9,
    'DualAllocationDetailed' = 10,
    'TimeSurveyByHours' = 11
}